import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDirection, IDirectionsInitialState, IDirectionsList } from '@types';

import { initialDirections } from './initialState';

export const directionsSlice = createSlice({
    name: 'directions',
    initialState: initialDirections(),
    reducers: {
        setDirections(state: IDirectionsInitialState, action: PayloadAction<IDirectionsList>) {
            state.directionsList = action.payload;
        },

        setDirection(state: IDirectionsInitialState, action: PayloadAction<IDirection | null>) {
            state.direction = action.payload;
        },
    },
});
